// React
import { useState, useEffect, useCallback } from 'react';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Button,
    Input, 
    Link,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@aws-amplify/ui-react';

import { callBackend } from './api.js';

export default function ListForDate({
    showHistoryFn
}) {
    const [list, setList] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [theDate, setTheDate] = useState(getDateWeekAgo);
    const [dayOfWeek, setDayOfWeek] = useState("");

    function getDateWeekAgo() {
        const today = new Date();
        const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        const day = String(weekAgo.getDate()).padStart(2, '0');
        const month = String(weekAgo.getMonth() + 1).padStart(2, '0');
        const year = weekAgo.getFullYear();
        const returnValue = `${year}-${month}-${day}`;
        return returnValue;
    }

    const refreshData = useCallback(async () => {
        getExercises();
    }, [theDate]);

    useEffect(() => {
        refreshData();
        const day = new Date(theDate).getDay();
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        setDayOfWeek(days[day]);    
    }, [theDate, refreshData]);
    
    async function getExercises() {
        if (theDate === "") {
            setList([]); 
        } else {
            var requiredDate = theDate.replace("-","/").replace("-","/");
            setIsRefreshing(true); 
            
            const myInit = {
                date: requiredDate
            };

            try {
                const apiResult = await callBackend("workouts", "GET", myInit);

                setList(await apiResult);
            } catch (e) {
                setList([]);
                alert(`Error refreshing workouts: ${e}`);
            }
            setIsRefreshing(false);
        }
    };

    
    // Return table rows of instances
    function ExerciseRows() {
        list.forEach((item, index) => {
            if (index < list.length - 1) {
                let diff = (list[index + 1].when - item.when); // difference in seconds
                const minutes = Math.floor(diff / 60);
                const seconds = diff % 60;
                item.diff = `${minutes} min ${seconds} sec`;
            } else {
                item.diff = -1;
            }
            const date = new Date(item.when * 1000);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            item.prettyDate = `${hours}:${minutes}:${seconds}`;
        });
        return list.map((i) => {
            return (
                <TableRow key={i.name+i.order}>
                    <TableCell>
                        <Link 
                            onClick={(e) => showHistoryFn(i.name)}
                        >
                            {i.order}. {i.name} 
                        </Link>
                    </TableCell>
                    <TableCell style={{fontSize:'12px'}}>
                        {i.prettyDate}
                    </TableCell>
                    <TableCell style={{fontSize:'12px'}}>
                        {i.diff !== -1 ? i.diff : ""}
                    </TableCell>
                </TableRow>
            );
        });
    }

    return (
        <><Table highlightOnHover={true} variation="striped">
            <TableHead>
                <TableRow>
                    <TableCell as="th" colSpan={3} textAlign="center">
                        <div style={{ marginTop: '10px' }}>
                            <b>{dayOfWeek}</b>
                        </div>
                        <div>
                            <Button 
                                onClick={() => {
                                    const currentDate = new Date(theDate);
                                    currentDate.setDate(currentDate.getDate() - 7);
                                    setTheDate(currentDate.toISOString().split('T')[0]);
                                }}
                            >
                                &lt;&lt;
                            </Button>
                            <Button 
                                onClick={() => {
                                    const currentDate = new Date(theDate);
                                    currentDate.setDate(currentDate.getDate() - 1);
                                    setTheDate(currentDate.toISOString().split('T')[0]);
                                }}
                            >
                                &lt;
                            </Button>
                            <Input
                                style ={{ width: '100px', fontSize: '12px', padding: '1px' }}
                                label="See exercises for a specific date:"
                                value={theDate}
                                disabled={isRefreshing}
                                onChange={(e) => setTheDate(e.target.value)}
                                type="date" />
                            <Button 
                                onClick={() => {
                                    const currentDate = new Date(theDate);
                                    currentDate.setDate(currentDate.getDate() + 1);
                                    setTheDate(currentDate.toISOString().split('T')[0]);
                                }}
                            >
                                &gt;
                            </Button>
                            <Button 
                                onClick={() => {
                                    const currentDate = new Date(theDate);
                                    currentDate.setDate(currentDate.getDate() + 7);
                                    setTheDate(currentDate.toISOString().split('T')[0]);
                                }}
                            >
                                &gt;&gt;
                            </Button>
                        </div>
                </TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
                {list.length === 0 && !isRefreshing &&
                    <TableRow>
                        <TableCell colSpan={1} textAlign="center">
                            <b>No exercises for this date.</b>
                        </TableCell>
                    </TableRow>}
                {list.length > 0 && 
                    <ExerciseRows />
                }
            </TableBody>
            
        </Table>
        </>
    );
}
